import React from 'react'
import './noData.scss'

const NoData = ({ message }) => {
  return (
    <div className='container-no-data' role="status" aria-live="polite">
      <div className='card-no-data'>
        <div className='icon-no-data-wrapper'>
          <svg className='icon-no-data' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 2v6h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 15h6M9 12h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </div>
        <div className='text-no-data'>
          <p className='message-no-data'>{message}</p>
          <span className='hint-no-data'>Los datos aparecerán aquí cuando estén disponibles</span>
        </div>
      </div>
    </div>
  )
}

export default NoData